import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { store } from './_store'
import './_filters'
/*  tooltips */
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.config.productionTip = false
Vue.use(Tooltip);

new Vue({
  router,
  i18n,
  store,   
  render: h => h(App)
}).$mount('#app')
